import styles from "@/styles/app-guide.module.scss"
import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import Image from 'next/image'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function AppGuide() {

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout>
        <div className={`${styles['page-app-guide']}`}>

          <div className={styles['content']}>
            <Image
              className={styles['app-guide-banner']}
              src={`${imageDomain}/app-guide/phone.png`}
              alt={'male'}
              width={173}
              height={347}
            ></Image>
            
            <div className={styles['content-right']}>
              <div className={styles['title']}>Scan QR code to access</div>
              <div className={styles['desc']}>Crazysales Mobile Site</div>
              <div className={styles['desc']}>Great Deals at Your Fingertips.</div>

              <div className={styles['scan-box']}>
                <Image
                  className={styles['scan-img']}
                  src={`${imageDomain}/app-guide/qr-code.png`}
                  alt={'qr-code'}
                  width={220}
                  height={220}
                ></Image>
              </div>

            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}